(function() {
  const floatingBtn = document.getElementById('floatingBtn');
  if (!floatingBtn) return;
  window.addEventListener('scroll', () => {
    floatingBtn.classList.toggle('hidden', window.scrollY < 550);
    floatingBtn.classList.toggle('flex', window.scrollY >= 550);
  });
})();
(function() {
  const toasts = [document.getElementById('toast1'), document.getElementById('toast2'), document.getElementById('toast3')].filter(Boolean);
  if (!toasts.length) return;
  let ti = 0;

  function showToast() {
    toasts.forEach(t => t.classList.add('hidden'));
    toasts[ti].classList.remove('hidden');
    setTimeout(() => {
      toasts[ti].classList.add('hidden');
      ti = (ti + 1) % toasts.length;
    }, 5000);
  }
  setTimeout(() => {
    showToast();
    setInterval(showToast, 32000);
  }, 30000);
})();
(function() {
  const track = document.getElementById('sliderTrack');
  const dots = document.querySelectorAll('.gallery-dot');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const container = document.getElementById('sliderContainer');
  if (!track || !prevBtn || !nextBtn || !container) return;
  const slides = track.querySelectorAll(':scope > div');
  const totalSlides = (typeof wp_total_images !== 'undefined' && wp_total_images > 0) ? wp_total_images : (window.product_data?.images?.length || slides.length);
  let currentSlide = 0;
  let startX = 0;
  let isDragging = false;

  function goToSlide(index) {
    if (index < 0) index = totalSlides - 1;
    if (index >= totalSlides) index = 0;
    currentSlide = index;
    track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    dots.forEach((dot, i) => {
      dot.classList.toggle('bg-ember', i === currentSlide);
      dot.classList.toggle('bg-inkMid', i !== currentSlide);
    });
  }
  prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
  nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));
  dots.forEach(dot => {
    dot.addEventListener('click', () => goToSlide(parseInt(dot.dataset.index, 10)));
  });
  container.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  }, {
    passive: true
  });
  container.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    isDragging = false;
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) goToSlide(currentSlide + (diff > 0 ? 1 : -1));
  }, {
    passive: true
  });
  goToSlide(0);
})();
(function() {
    const galleryItems = document.querySelectorAll('.review-img');
    const slider = document.getElementById('imageSlider');
    const sliderImg = document.getElementById('sliderImage');
    const sliderUser = document.getElementById('sliderUser');
    const sliderStars = document.getElementById('sliderStars');
    const sliderCounter = document.getElementById('sliderCounter');
    const sliderCTA = document.getElementById('sliderCTA');
    if (!slider || !sliderImg || !galleryItems.length) return;
    const images = Array.from(galleryItems);
    let currentIndex = 0;

    function updateSlider() {
      const item = images[currentIndex];
      const img = item.querySelector('img');
      sliderImg.src = img.src;
      if (sliderUser) sliderUser.textContent = item.dataset.user || '';
      const rating = parseInt(item.dataset.rating, 10) || 5;
      if (sliderStars) {
        sliderStars.innerHTML = Array(rating).fill('<i class="fa-solid fa-star"></i>').join('');
        }
        if (sliderCounter) sliderCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
      }

      function openSlider(index) {
        currentIndex = index;
        updateSlider();
        slider.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      }

      function closeSlider() {
        slider.classList.add('hidden');
        document.body.style.overflow = '';
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % images.length;
        updateSlider();
      }

      function prevSlide() {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateSlider();
      }
      galleryItems.forEach((item, index) => {
        item.addEventListener('click', () => openSlider(index));
      });
      const backBtn = document.getElementById('sliderBackBtn');
      const nextBtn = document.getElementById('sliderNextBtn');
      const prevBtn = document.getElementById('sliderPrevBtn');
      if (backBtn) backBtn.addEventListener('click', closeSlider);
      if (nextBtn) nextBtn.addEventListener('click', nextSlide);
      if (prevBtn) prevBtn.addEventListener('click', prevSlide);
      if (sliderCTA) sliderCTA.addEventListener('click', closeSlider);
      slider.addEventListener('click', (e) => {
        if (e.target === slider) closeSlider();
      });
      document.addEventListener('keydown', (e) => {
        if (slider.classList.contains('hidden')) return;
        if (e.key === 'Escape') closeSlider();
        if (e.key === 'ArrowRight') nextSlide();
        if (e.key === 'ArrowLeft') prevSlide();
      });
      let touchStartX = 0;
      let touchStartY = 0;
      slider.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, {
        passive: true
      });
      slider.addEventListener('touchend', (e) => {
        const diffX = touchStartX - e.changedTouches[0].clientX;
        const diffY = touchStartY - e.changedTouches[0].clientY;
        if (Math.abs(diffY) > 80 && diffY < 0) closeSlider();
        else if (Math.abs(diffX) > 50) {
          if (diffX > 0) nextSlide();
          else prevSlide();
        }
      }, {
        passive: true
      });
    })();
  (function() {
    const faqBtns = document.querySelectorAll('.faq-btn');
    if (!faqBtns.length) return;
    faqBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.parentElement;
        const content = item.querySelector('.faq-content');
        const icon = btn.querySelector('i');
        const isOpen = btn.dataset.open === 'true';
        document.querySelectorAll('.faq-item').forEach(otherItem => {
          if (otherItem !== item) {
            const c = otherItem.querySelector('.faq-content');
            const b = otherItem.querySelector('.faq-btn');
            const i = otherItem.querySelector('.faq-btn i');
            if (c) c.classList.add('hidden');
            if (b) b.dataset.open = 'false';
            if (i) i.classList.remove('rotate-180');
          }
        });
        if (isOpen) {
          content.classList.add('hidden');
          btn.dataset.open = 'false';
          icon.classList.remove('rotate-180');
        } else {
          content.classList.remove('hidden');
          btn.dataset.open = 'true';
          icon.classList.add('rotate-180');
        }
      });
    });
  })();
